import { styled } from 'styled-components'
import { Heading } from 'suomifi-ui-components'

export const ErrorMainHeading = styled(Heading)`
  padding: ${(props) => `0 ${props.theme.spacing.m}`};
  margin: ${(props) => `${props.theme.spacing.xxl} 0 ${props.theme.spacing.m}`};
`
